import React from 'react'
import BannerMainImageSection from '../../../bannerMainImageSection'
import BannerBrandImageSection from '../../../bannerBrandImageSection'
import * as E from '../homeElements'
import { Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { IProposalAcceptedWithoutNextStepsStageProps } from '../stages/interfaces/IProposalAcceptedWithoutNextStepsStageProps'

//TODO rename this AllCompletedStage ?
const ProposalAcceptedWithoutNextStepsStage = (
  props: IProposalAcceptedWithoutNextStepsStageProps
) => {
  const { firstName, theme, settlementLink, proposalLink, digitalSettlement } =
    props

  return (
    <>
      <BannerMainImageSection
        src="/images/banner-home-page-accepting-estimate.jpg"
        id="proposalacceptedalldonestage.bannermainsection"
      >
        Congratulations {firstName}!
      </BannerMainImageSection>

      <BannerBrandImageSection id="maincontent">
        <E.ContainerBlock theme={theme}>
          <E.BannerButtonLinkParent>
            <Col sm={7}>
              <Row>
                <div id="proposalacceptedalldonestage.content">
                  You're all done! Now that the financier has finalised your
                  lease, there are no additional steps to complete.
                  <br />
                  Once you receive confirmation of settlement, don't forget to
                  download the Maxxia app to your mobile which will help you
                  keep track of things moving forward!
                </div>
              </Row>
            </Col>
            <E.BannerButtonLinkChild>
              {digitalSettlement && (
                <>
                  <Link to={settlementLink} tabIndex={-1}>
                    <E.BannerPrimaryInverted id="proposalacceptedalldonestage.gotosettlements">
                      View paperwork
                    </E.BannerPrimaryInverted>
                  </Link>

                  <br />
                  <br />
                </>
              )}
              <Link to={proposalLink} tabIndex={-1}>
                <E.BannerPrimaryButton
                  id="proposalacceptedalldonestage.viewproposal"
                  invertColor
                >
                  View my proposal again
                </E.BannerPrimaryButton>
              </Link>
            </E.BannerButtonLinkChild>
          </E.BannerButtonLinkParent>
        </E.ContainerBlock>
      </BannerBrandImageSection>
    </>
  )
}

export default ProposalAcceptedWithoutNextStepsStage
